import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

const TopNavContext = React.createContext();

export const TopNavContextProvider = (props) => {
  const { children } = props;
  const [component, setComponent] = useState(null);
  const [hideBackButton, setHideBackButton] = useState(null);

  return (
    <TopNavContext.Provider
      value={{
        component,
        setComponent,
        hideBackButton,
        setHideBackButton,
        isBarVisible: true,
      }}
    >
      {children}
    </TopNavContext.Provider>
  );
};

TopNavContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useTopNavContext = () => useContext(TopNavContext);
